module.exports = __webpack_public_path__ + "img/icon.aed63c30.png";